export function sanitizeNotes(notes: string): string {
  return notes?.replace(/<[^>]*>/gm, ' ') ?? '';
}
